<template>
    <div class="platform-container">
        <el-card class="box-card">
            <div class="card-header">
                <span>联系方式</span>
            </div>
            <div class="platform-form">
                <el-form
                    :model="formData"
                    :rules="rules"
                    ref="formRef"
                    label-width="100px"
                >
                    <!-- <el-form-item label="联系电话" prop="phone">
                        <el-input
                            v-model="formData.phone"
                            placeholder="请输入联系电话"
                        ></el-input>
                    </el-form-item> -->
                    <el-form-item label="联系邮箱" prop="email">
                        <el-input
                            v-model="formData.email"
                            placeholder="请输入联系邮箱"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="联系地址" prop="address">
                        <el-input
                            v-model="formData.address"
                            placeholder="请输入联系地址"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="微信二维码" prop="wechat">
                        <upload-image
                            :width="150"
                            :height="150"
                            :maxSize="20"
                            key="wechat"
                            ref="uploadImage"
                            @on-change="handleImageChange($event, 'wechat')"
                            @on-remove="handleImageRemove('wechat')"
                        />
                    </el-form-item>
                    <el-form-item label="微博二维码" prop="weibo">
                        <upload-image
                            :width="150"
                            :height="150"
                            :maxSize="20"
                            key="weibo"
                            ref="uploadImageWeibo"
                            @on-change="handleImageChange($event, 'weibo')"
                            @on-remove="handleImageRemove('weibo')"
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm"
                            >保存</el-button
                        >
                        <el-button @click="resetForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
import { infoServicePage, infoServiceSubmit } from "@/api/admin";
export default {
    name: "Platform",
    data() {
        return {
            formData: {
                phone: "",
                email: "",
                address: "",
                wechat: "",
                weibo: "",
            },
            rules: {
                phone: [
                    {
                        required: true,
                        message: "请输入联系电话",
                        trigger: "blur",
                    },
                    {
                        pattern: /^\d{3,4}-\d{7,8}$|^1[3-9]\d{9}$/,
                        message: "请输入正确的电话格式",
                        trigger: "blur",
                    },
                ],
                email: [
                    {
                        required: true,
                        message: "请输入联系邮箱",
                        trigger: "blur",
                    },
                    {
                        type: "email",
                        message: "请输入正确的邮箱格式",
                        trigger: "blur",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "请输入联系地址",
                        trigger: "blur",
                    },
                ],
                // wechat: [
                //     {
                //         required: true,
                //         message: "请上传微信二维码",
                //         trigger: "blur",
                //     },
                // ],
                // weibo: [
                //     {
                //         required: true,
                //         message: "请上传微博二维码",
                //         trigger: "blur",
                //     },
                // ],
            },
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        handleImageChange(file,type) {
            console.log(file,type,'-----');
            if(type === 'wechat'){
                this.formData.wechat = file
            }else if(type === 'weibo'){
                this.formData.weibo = file
            }
        },
        handleImageRemove(type) {
            if(type === 'wechat'){
                this.formData.wechat = ""
            }else if(type === 'weibo'){
                this.formData.weibo = ""
            }
        },
        // 获取平台信息
        getInfo() {
            // TODO: 调用接口获取数据
            infoServicePage().then((res) => {
                let data = res.data.records;
                if (data.length === 0) {
                    this.formData = {};
                    return;
                } else {
                    this.formData = data[0];
                    if (data[0].wechat) {
                        console.log(data[0].wechat);
                        this.$refs.uploadImage.setFiles(data[0].wechat);
                    }
                    if (data[0].weibo) {
                        this.$refs.uploadImageWeibo.setFiles(data[0].weibo);
                    }
                }
            });
            // setTimeout(() => {
            //     this.formData = {
            //         phone: "400-888-8888",
            //         email: "support@platform.com",
            //         address: "上海市浦东新区张江高科技园区",
            //         qrcode: "",
            //         surveyUrl: "https://www.example.com/survey",
            //     };
            // }, 500);
        },
        // 提交表单
        submitForm() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    // TODO: 调用接口保存数据
                    // this.$message.success("保存成功");
                    infoServiceSubmit(this.formData).then((res) => {
                        this.$message.success("保存成功");
                    });
                }
            });
        },
        // 重置表单
        resetForm() {
            this.$refs.formRef.resetFields();
            this.$refs.uploadImage.setFiles("");
            this.$refs.uploadImageWeibo.setFiles("");
        },
        // 上传二维码成功
        handleQrcodeSuccess(res) {
            // TODO: 处理上传成功后的逻辑
            this.formData.qrcode = res.url;
        },
        // 上传二维码前的校验
        beforeQrcodeUpload(file) {
            const isJPGOrPNG =
                file.type === "image/jpeg" || file.type === "image/png";
            const isLt10M = file.size / 1024 / 1024 < 10;

            if (!isJPGOrPNG) {
                this.$message.error("只能上传JPG/PNG格式的图片！");
            }
            if (!isLt10M) {
                this.$message.error("图片大小不能超过10MB！");
            }
            return isJPGOrPNG && isLt10M;
        },
    },
};
</script>

<style lang="scss" scoped>
.platform-container {
    .card-header {
        margin-bottom: 20px;
        font-size: 16px;
        font-weight: bold;
    }

    .platform-form {
        width: 600px;
    }

    ::v-deep .avatar-uploader {
        .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;

            &:hover {
                border-color: #409eff;
            }
        }
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }

    .qrcode {
        width: 120px;
        height: 120px;
        display: block;
    }

    .upload-tip {
        font-size: 12px;
        color: #606266;
        margin-top: 5px;
    }
}
</style>
